export const PROGRESS_START_REQUEST = 'PROGRESS_START_REQUEST'
export const PROGRESS_START = 'PROGRESS_START'

export const PROGRESS_STOP_REQUEST = 'PROGRESS_STOP_REQUEST'
export const PROGRESS_STOP = 'PROGRESS_STOP'

export const FETCH_ERROR_REQUEST_SERVER = 'FETCH_ERROR_REQUEST_SERVER'
export const FETCH_ERROR_REQUEST_CLIENT = 'FETCH_ERROR_REQUEST_CLIENT'

export const FETCH_ERROR_CLIENT = 'FETCH_ERROR_CLIENT'
export const FETCH_ERROR_SERVER = 'FETCH_ERROR_SERVER'

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'

export const FETCH_USER_DETAIL_REQUEST = 'FETCH_USER_DETAIL_REQUEST'
export const FETCH_USER_DETAIL_SUCCESS = 'FETCH_USER_DETAIL_SUCCESS'
export const FETCH_USER_DETAIL_FAILURE = 'FETCH_USER_DETAIL_FAILURE'

export const USER_DETAIL_RESET_REQUEST = 'USER_DETAIL_RESET_REQUEST'
export const USER_DETAIL_RESET_SUCCESS = 'USER_DETAIL_RESET_SUCCESS'
export const USER_DETAIL_RESET_FAILURE = 'USER_DETAIL_RESET_FAILURE'

export const DETAIL_USER_CLEAN_REQUEST = 'DETAIL_USER_CLEAN_REQUEST'
export const DETAIL_USER_CLEAN = 'DETAIL_USER_CLEAN'

export const SAVE_USER_CREATE_REQUEST = 'SAVE_USER_CREATE_REQUEST'
export const SAVE_USER_CREATE_SUCCESS = 'SAVE_USER_CREATE_SUCCESS'
export const SAVE_USER_CREATE_FAILURE = 'SAVE_USER_CREATE_FAILURE'

export const CHECK_BANK_ADMIN_CORPORATE_REQUEST = 'CHECK_BANK_ADMIN_CORPORATE_REQUEST'
export const CHECK_BANK_ADMIN_CORPORATE = 'CHECK_BANK_ADMIN_CORPORATE'

export const FETCH_USER_EDIT_REQUEST = 'FETCH_USER_EDIT_REQUEST'
export const FETCH_USER_EDIT_SUCCESS = 'FETCH_USER_EDIT_SUCCESS'
export const FETCH_USER_EDIT_FAILURE = 'FETCH_USER_EDIT_FAILURE'

export const UPDATE_USER_EDIT_REQUEST = 'UPDATE_USER_EDIT_REQUEST'
export const UPDATE_USER_EDIT_SUCCESS = 'UPDATE_USER_EDIT_SUCCESS'
export const UPDATE_USER_EDIT_FAILURE = 'UPDATE_USER_EDIT_FAILURE'

export const EDIT_USER_ID_BANK_FIELD_CHANGE_REQUEST = 'EDIT_USER_ID_BANK_FIELD_CHANGE_REQUEST'
export const EDIT_USER_ID_BANK_FIELD_CHANGE = 'EDIT_USER_ID_BANK_FIELD_CHANGE'

export const EDIT_USER_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST = 'EDIT_USER_CORPORATE_ID_FIELD_CHANGE_REQUEST'
export const EDIT_USER_CORPORATE_SENDER_ID_FIELD_CHANGE = 'EDIT_USER_CORPORATE_ID_FIELD_CHANGE'

export const EDIT_USER_FULL_NAME_FIELD_CHANGE_REQUEST = 'EDIT_USER_FULL_NAME_FIELD_CHANGE_REQUEST'
export const EDIT_USER_FULL_NAME_FIELD_CHANGE = 'EDIT_USER_FULL_NAME_FIELD_CHANGE'

export const EDIT_USER_DESCRIPTION_FIELD_CHANGE_REQUEST = 'EDIT_USER_DESCRIPTION_FIELD_CHANGE_REQUEST'
export const EDIT_USER_DESCRIPTION_FIELD_CHANGE = 'EDIT_USER_DESCRIPTION_FIELD_CHANGE'

export const EDIT_USER_ENABLED_FIELD_CHANGE_REQUEST = 'EDIT_USER_ENABLED_FIELD_CHANGE_REQUEST'
export const EDIT_USER_ENABLED_FIELD_CHANGE = 'EDIT_USER_ENABLED_FIELD_CHANGE'

export const EDIT_USER_USERNAME_FIELD_CHANGE_REQUEST = 'EDIT_USER_USERNAME_FIELD_CHANGE_REQUEST'
export const EDIT_USER_USERNAME_FIELD_CHANGE = 'EDIT_USER_USERNAME_FIELD_CHANGE'

export const EDIT_USER_PHONE_FIELD_CHANGE_REQUEST = 'USER_PHONE_FIELD_CHANGE_REQUEST'
export const EDIT_USER_PHONE_FIELD_CHANGE = 'EDIT_USER_PHONE_FIELD_CHANGE'

export const EDIT_USER_EMAIL_FIELD_CHANGE_REQUEST = 'EDIT_USER_EMAIL_FIELD_CHANGE_REQUEST'
export const EDIT_USER_EMAIL_FIELD_CHANGE = 'EDIT_USER_EMAIL_FIELD_CHANGE'

export const EDIT_USER_RESET_FIELD_CHANGE_REQUEST = 'EDIT_USER_RESET_FIELD_CHANGE_REQUEST'
export const EDIT_USER_RESET_FIELD_CHANGE = 'EDIT_USER_RESET_FIELD_CHANGE'

export const EDIT_USER_CORPORATE_PERMISSION_CHANGE_REQUEST = 'EDIT_USER_CORPORATE_PERMISSION_CHANGE_REQUEST'
export const EDIT_USER_CORPORATE_PERMISSION_CHANGE = 'EDIT_USER_CORPORATE_PERMISSION_CHANGE'
export const EDIT_USER_CORPORATE_PERMISSION_LIST_REQUEST = 'EDIT_USER_CORPORATE_PERMISSION_LIST_REQUEST'
export const EDIT_USER_CORPORATE_PERMISSION_LIST = 'EDIT_USER_CORPORATE_PERMISSION_LIST'

export const EDIT_USER_ROLE_FIELD_CHANGE_REQUEST = 'EDIT_USER_ROLE_FIELD_CHANGE_REQUEST'
export const EDIT_USER_ROLE_FIELD_CHANGE = 'EDIT_USER_ROLE_FIELD_CHANGE'

export const EDIT_USER_CLEAN_REQUEST = 'EDIT_USER_CLEAN_REQUEST'
export const EDIT_USER_CLEAN = 'EDIT_USER_CLEAN'

export const CREATE_USER_ID_BANK_FIELD_CHANGE_REQUEST = 'CREATE_USER_ID_BANK_FIELD_CHANGE_REQUEST'
export const CREATE_USER_ID_BANK_FIELD_CHANGE = 'CREATE_USER_ID_BANK_FIELD_CHANGE'

export const EDIT_USER_PASSWORD_FIELD_CHANGE_REQUEST = 'EDIT_USER_PASSWORD_FIELD_CHANGE_REQUEST'
export const EDIT_USER_PASSWORD_FIELD_CHANGE = 'EDIT_USER_PASSWORD_FIELD_CHANGE'

export const CREATE_USER_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST = 'CREATE_USER_CORPORATE_ID_FIELD_CHANGE_REQUEST'
export const CREATE_USER_CORPORATE_SENDER_ID_FIELD_CHANGE = 'CREATE_USER_CORPORATE_ID_FIELD_CHANGE'

export const CREATE_USER_FULL_NAME_FIELD_CHANGE_REQUEST = 'CREATE_USER_FULL_NAME_FIELD_CHANGE_REQUEST'
export const CREATE_USER_FULL_NAME_FIELD_CHANGE = 'CREATE_USER_FULL_NAME_FIELD_CHANGE'

export const CREATE_USER_DESCRIPTION_FIELD_CHANGE_REQUEST = 'CREATE_USER_DESCRIPTION_FIELD_CHANGE_REQUEST'
export const CREATE_USER_DESCRIPTION_FIELD_CHANGE = 'CREATE_USER_DESCRIPTION_FIELD_CHANGE'

export const CREATE_USER_ENABLED_FIELD_CHANGE_REQUEST = 'CREATE_USER_ENABLED_FIELD_CHANGE_REQUEST'
export const CREATE_USER_ENABLED_FIELD_CHANGE = 'CREATE_USER_ENABLED_FIELD_CHANGE'

export const CREATE_USER_USERNAME_FIELD_CHANGE_REQUEST = 'CREATE_USER_USERNAME_FIELD_CHANGE_REQUEST'
export const CREATE_USER_USERNAME_FIELD_CHANGE = 'CREATE_USER_USERNAME_FIELD_CHANGE'

export const CREATE_USER_PHONE_FIELD_CHANGE_REQUEST = 'CREATE_USER_PHONE_FIELD_CHANGE_REQUEST'
export const CREATE_USER_PHONE_FIELD_CHANGE = 'CREATE_USER_PHONE_FIELD_CHANGE'

export const CREATE_USER_EMAIL_FIELD_CHANGE_REQUEST = 'CREATE_USER_EMAIL_FIELD_CHANGE_REQUEST'
export const CREATE_USER_EMAIL_FIELD_CHANGE = 'CREATE_USER_EMAIL_FIELD_CHANGE'

export const CREATE_USER_RESET_FIELD_CHANGE_REQUEST = 'CREATE_USER_RESET_FIELD_CHANGE_REQUEST'
export const CREATE_USER_RESET_FIELD_CHANGE = 'CREATE_USER_RESET_FIELD_CHANGE'

export const CREATE_USER_PASSWORD_FIELD_CHANGE_REQUEST = 'CREATE_USER_PASSWORD_FIELD_CHANGE_REQUEST'
export const CREATE_USER_PASSWORD_FIELD_CHANGE = 'CREATE_USER_PASSWORD_FIELD_CHANGE'

export const CREATE_USER_ROLE_FIELD_CHANGE_REQUEST = 'CREATE_USER_ROLE_FIELD_CHANGE_REQUEST'
export const CREATE_USER_ROLE_FIELD_CHANGE = 'CREATE_USER_ROLE_FIELD_CHANGE'

export const CREATE_USER_CLEAN_REQUEST = 'CREATE_USER_CLEAN_REQUEST'
export const CREATE_USER_CLEAN = 'CREATE_USER_CLEAN'

export const CREATE_USER_CURRENTROLE = 'CREATE_USER_CURRENTROLE'

export const AUTHENTICATION_RECOVERY_REQUEST = 'AUTHENTICATION_RECOVERY_REQUEST'
export const AUTHENTICATION_RECOVERY_SUCCESS = 'AUTHENTICATION_RECOVERY_SUCCESS'
export const AUTHENTICATION_RECOVERY_FAILURE = 'AUTHENTICATION_RECOVERY_FAILURE'

export const CHANGE_LANGUAGE_REQUEST = 'CHANGE_LANGUAGE_REQUEST'
export const CHANGE_LANGUAGE_FIELD_REQUEST = 'CHANGE_LANGUAGE_REQUEST'
export const CHANGE_LANGUAGE_SUCCESS = 'CHANGE_LANGUAGE_SUCCESS'
export const CHANGE_LANGUAGE_FAILURE = 'CHANGE_LANGUAGE_FAILURE'

export const AUTHENTICATION_LOGIN_REQUEST = 'AUTHENTICATION_LOGIN_REQUEST'
export const AUTHENTICATION_CLEAN_ERROR = 'AUTHENTICATION_CLEAN_ERROR'
export const AUTHENTICATION_LOGIN_SUCCESS = 'AUTHENTICATION_LOGIN_SUCCESS'
export const AUTHENTICATION_LOGIN_FAILURE = 'AUTHENTICATION_LOGIN_FAILURE'

export const PLICK_STATS_BANK_FIELD_CHANGE_REQUEST='PLICK_STATS_BANK_FIELD_CHANGE_REQUEST'
export const PLICK_STATS_BANK_FIELD_CHANGE='PLICK_STATS_BANK_FIELD_CHANGE'

export const AUTHENTICATION_OTP_REQUEST = 'AUTHENTICATION_OTP_REQUEST'
export const AUTHENTICATION_OTP_SUCCESS = 'AUTHENTICATION_OTP_SUCCESS'
export const AUTHENTICATION_OTP_FAILURE = 'AUTHENTICATION_OTP_FAILURE'

export const AUTHENTICATION_INVALIDATE_SESSION='AUTHENTICATION_INVALIDATE_SESSION'
export const AUTHENTICATION_RESEND_OTP='AUTHENTICATION_RESEND_OTP'

export const DOWNLOAD_CORPORATE_TEMPLATE_REQUEST='DOWNLOAD_CORPORATE_TEMPLATE'
export const DOWNLOAD_CORPORATE_TEMPLATE_SUCCESS='DOWNLOAD_CORPORATE_TEMPLATE_SUCCESS'
export const DOWNLOAD_CORPORATE_TEMPLATE_FAILURE='DOWNLOAD_CORPORATE_TEMPLATE_FAILURE'

export const AUTHENTICATION_LOGOUT_REQUEST  = 'AUTHENTICATION_LOGOUT_REQUEST '
export const AUTHENTICATION_LOGOUT_SUCCESS = 'AUTHENTICATION_LOGOUT_SUCCESS'
export const AUTHENTICATION_LOGOUT_FAILURE = 'AUTHENTICATION_LOGOUT_FAILURE'

export const RECOVER_PASSWORD_REQUEST = 'RECOVER_PASSWORD_REQUEST'
export const RECOVER_PASSWORD_SUCCESS = 'RECOVER_PASSWORD_SUCCESS'
export const RECOVER_PASSWORD_FAILURE = 'RECOVER_PASSWORD_FAILURE'

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'

export const CHANGE_RESET_PASSWORD_REQUEST = 'CHANGE_RESET_PASSWORD_REQUEST'

export const RESET_USER_REQUEST = 'RESET_USER_REQUEST'
export const RESET_USER_SUCCESS = 'RESET_USER_SUCCESS'
export const RESET_USER_FAILURE = 'RESET_USER_FAILURE'

export const DISABLE_USER_REQUEST = 'DISABLE_USER_REQUEST'
export const DISABLE_USER_SUCCESS = 'DISABLE_USER_SUCCESS'
export const DISABLE_USER_FAILURE = 'DISABLE_USER_FAILURE'

export const ENABLE_USER_REQUEST = 'ENABLE_USER_REQUEST'
export const ENABLE_USER_SUCCESS = 'ENABLE_USER_SUCCESS'
export const ENABLE_USER_FAILURE = 'ENABLE_USER_FAILURE'

export const FETCH_ROLES_REQUEST = 'FETCH_ROLES_REQUEST'
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS'
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE'

export const FETCH_BANKS_REQUEST = 'FETCH_BANKS_REQUEST'
export const FETCH_BANKS_SUCCESS = 'FETCH_BANKS_SUCCESS'
export const FETCH_BANKS_FAILURE = 'FETCH_BANKS_FAILURE'

export const FETCH_BANK_DETAIL_REQUEST = 'FETCH_BANK_DETAIL_REQUEST'
export const FETCH_BANK_DETAIL_SUCCESS = 'FETCH_BANK_DETAIL_SUCCESS'
export const FETCH_BANK_DETAIL_FAILURE = 'FETCH_BANK_DETAIL_FAILURE'

export const FETCH_BANK_EDIT_REQUEST = 'FETCH_BANK_EDIT_REQUEST'
export const FETCH_BANK_EDIT_SUCCESS = 'FETCH_BANK_EDIT_SUCCESS'
export const FETCH_BANK_EDIT_FAILURE = 'FETCH_BANK_EDIT_FAILURE'

export const DETAIL_BANK_CLEAN_REQUEST = 'DETAIL_BANK_CLEAN_REQUEST'
export const EDIT_BANK_CLEAN_REQUEST = 'EDIT_BANK_CLEAN_REQUEST'

export const UPDATE_BANK_EDIT_REQUEST = 'UPDATE_BANK_EDIT_REQUEST'
export const UPDATE_BANK_EDIT_SUCCESS = 'UPDATE_BANK_EDIT_SUCCESS'
export const UPDATE_BANK_EDIT_FAILURE = 'UPDATE_BANK_EDIT_FAILURE'

export const ENABLE_BANK_REQUEST = 'ENABLE_BANK_REQUEST'
export const ENABLE_BANK_SUCCESS = 'ENABLE_BANK_SUCCESS'
export const ENABLE_BANK_FAILURE = 'ENABLE_BANK_FAILURE'

export const DISABLE_BANK_REQUEST = 'DISABLE_BANK_REQUEST'
export const DISABLE_BANK_SUCCESS = 'DISABLE_BANK_SUCCESS'
export const DISABLE_BANK_FAILURE = 'DISABLE_BANK_FAILURE'

export const CREATE_BANK_CLEAN = 'CREATE_BANK_CLEAN'

export const EDIT_BANK_ENABLED_FIELD_CHANGE_REQUEST = 'EDIT_BANK_ENABLED_FIELD_CHANGE_REQUEST'
export const EDIT_BANK_ENABLED_FIELD_CHANGE = 'EDIT_BANK_ENABLED_FIELD_CHANGE'

export const EDIT_BANK_CORPORATE_FIELD_CHANGE_REQUEST = 'EDIT_BANK_CORPORATE_FIELD_CHANGE_REQUEST'
export const EDIT_BANK_CORPORATE_FIELD_CHANGE = 'EDIT_BANK_CORPORATE_FIELD_CHANGE'

export const EDIT_BANK_BANK_CONTACT_FIELD_CHANGE_REQUEST = 'EDIT_BANK_BANK_CONTACT_FIELD_CHANGE_REQUEST'
export const EDIT_BANK_BANK_CONTACT_FIELD_CHANGE = 'EDIT_BANK_BANK_CONTACT_FIELD_CHANGE'

export const EDIT_BANK_CLEAN = 'EDIT_BANK_CLEAN'

export const DETAIL_BANK_CLEAN = 'DETAIL_BANK_CLEAN'

export const DETAIL_CORPORATE_CLEAN_REQUEST = 'REQUEST DETAIL_CORPORATE_CLEAN_REQUEST'

export const FETCH_CORPORATES_REQUEST = 'FETCH_CORPORATES_REQUEST'
export const FETCH_USER_CORPORATES_REQUEST = 'FETCH_USER_CORPORATES_REQUEST'
export const FETCH_USER_CORPORATES_SUCCESS = 'FETCH_USER_CORPORATES_SUCCESS'
export const FETCH_USER_CORPORATES_FAILURE = 'FETCH_USER_CORPORATES_FAILURE'
export const FETCH_CORPORATES_SUCCESS = 'FETCH_CORPORATES_SUCCESS'
export const FETCH_CORPORATES_FAILURE = 'FETCH_CORPORATES_FAILURE'
export const FETCH_USER_PERMISSION_LIST_REQUEST = 'FETCH_USER_PERMISSION_LIST_REQUEST'


export const FETCH_CORPORATE_DETAIL_REQUEST = 'FETCH_CORPORATE_DETAIL_REQUEST'
export const FETCH_CORPORATE_DETAIL_SUCCESS = 'FETCH_CORPORATE_DETAIL_SUCCESS'
export const FETCH_CORPORATE_DETAIL_FAILURE = 'FETCH_CORPORATE_DETAIL_FAILURE'

export const FETCH_CORPORATE_EDIT_REQUEST = 'FETCH_CORPORATE_EDIT_REQUEST'
export const FETCH_CORPORATE_EDIT_SUCCESS = 'FETCH_CORPORATE_EDIT_SUCCESS'
export const UPDATE_CORPORATE_EDIT_BANK_ID = 'UPDATE_CORPORATE_EDIT_BANK_ID'
export const FETCH_CORPORATE_EDIT_FAILURE = 'FETCH_CORPORATE_EDIT_FAILURE'

export const UPDATE_CORPORATE_EDIT_REQUEST = 'UPDATE_CORPORATE_EDIT_REQUEST'
export const UPDATE_CORPORATE_EDIT_SUCCESS = 'UPDATE_CORPORATE_EDIT_SUCCESS'
export const UPDATE_CORPORATE_EDIT_FAILURE = 'UPDATE_CORPORATE_EDIT_FAILURE'

export const EDIT_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE = 'EDIT_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE'

export const EDIT_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_CHECK_IBAN_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_CHECK_IBAN_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE = 'EDIT_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE'
export const EDIT_CORPORATE_CORPORATE_VOUCHER_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_VOUCHER_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_VOUCHER_FIELD_CHANGE = 'EDIT_CORPORATE_CORPORATE_VOUCHER_FIELD_CHANGE'
export const EDIT_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE = 'EDIT_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE'

export const EDIT_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE = 'EDIT_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE'


export const EDIT_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE = 'EDIT_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE'

export const EDIT_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE = 'EDIT_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE'

export const EDIT_CORPORATE_ENABLED_FILED_CHANGE_REQUEST = 'EDIT_CORPORATE_ENABLED_FILED_CHANGE_REQUEST'
export const EDIT_CORPORATE_ENABLED_FILED_CHANGE = 'EDIT_CORPORATE_ENABLED_FILED_CHANGE'

export const EDIT_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE = 'EDIT_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE'

export const EDIT_CORPORATE_ID_BANK_FIELD_CHANGE_REQUEST = 'EDIT_CORPORATE_ID_BANK_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_ID_BANK_FIELD_CHANGE = 'EDIT_CORPORATE_ID_BANK_FIELD_CHANGE'

export const EDIT_CORPORATE_CLEAN_REQUEST = 'EDIT_CORPORATE_CLEAN_REQUEST'






export const SAVE_CORPORATE_CREATE_REQUEST = 'SAVE_CORPORATE_CREATE_REQUEST'
export const SAVE_CORPORATE_CREATE_SUCCESS = 'SAVE_CORPORATE_CREATE_SUCCESS'
export const SAVE_CORPORATE_CREATE_FAILURE = 'SAVE_CORPORATE_CREATE_FAILURE'
export const SAVE_CORPORATE_CREATE_UPDATE_LIST = 'SAVE_CORPORATE_CREATE_UPDATE_LIST'

export const CREATE_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST'
export const CREATE_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE = 'CREATE_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE'

export const CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_CHANGE_REQUEST'
export const CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_ENABLE_CHANGE = 'CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_ENABLE_CHANGE'
export const CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_DISABLE_CHANGE = 'CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_DISABLE_CHANGE'
export const CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS = 'CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_NOT_EXIST'
export const CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS_REQUEST = 'CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS_REQUEST'


export const CREATE_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE_REQUEST'
export const CREATE_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE = 'CREATE_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE'

export const CREATE_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE_REQUEST'
export const CREATE_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE = 'CREATE_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE'

export const CREATE_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE_REQUEST'
export const CREATE_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE = 'CREATE_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE'

export const CREATE_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE_REQUEST'
export const CREATE_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE = 'CREATE_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE'


export const CREATE_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE_REQUEST'
export const CREATE_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE = 'CREATE_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE'


export const CREATE_CORPORATE_ENABLED_FILED_CHANGE_REQUEST = 'CREATE_CORPORATE_ENABLED_FILED_CHANGE_REQUEST'
export const CREATE_CORPORATE_ENABLED_FILED_CHANGE = 'CREATE_CORPORATE_ENABLED_FILED_CHANGE'

export const CREATE_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE_REQUEST'
export const CREATE_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE = 'CREATE_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE'

export const CREATE_CORPORATE_ID_BANK_FIELD_CHANGE_REQUEST = 'CREATE_CORPORATE_ID_BANK_FIELD_CHANGE_REQUEST'
export const CREATE_CORPORATE_ID_BANK_FIELD_CHANGE = 'CREATE_CORPORATE_ID_BANK_FIELD_CHANGE'

export const CREATE_CORPORATE_CLEAN_REQUEST = 'CREATE_CORPORATE_CLEAN_REQUEST'

export const DISABLE_CORPORATE_REQUEST = 'DISABLE_CORPORATE_REQUEST'
export const DISABLE_CORPORATE_SUCCESS = 'DISABLE_CORPORATE_SUCCESS'
export const DISABLE_CORPORATE_FAILURE = 'DISABLE_CORPORATE_FAILURE'

export const ENABLE_CORPORATE_REQUEST = 'ENABLE_CORPORATE_REQUEST'
export const ENABLE_CORPORATE_SUCCESS = 'ENABLE_CORPORATE_SUCCESS'
export const ENABLE_CORPORATE_FAILURE = 'ENABLE_CORPORATE_FAILURE'

export const CREATE_CORPORATE_CLEAN = 'CREATE_CORPORATE_CLEAN'

export const EDIT_CORPORATE_CLEAN = 'EDIT_CORPORATE_CLEAN'

export const EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_ENABLE_CHANGE = 'EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_ENABLE_CHANGE'
export const EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_DISABLE_CHANGE = 'EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_DISABLE_CHANGE'
export const EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS = 'EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS'
export const EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS_REQUEST = 'EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS_REQUEST'



export const DETAIL_CORPORATE_CLEAN = 'DETAIL_CORPORATE_CLEAN'

export const FETCH_CAMPAIGN_REQUEST = 'FETCH_CAMPAIGN_REQUEST'
export const FETCH_CAMPAIGN_SUCCESS = 'FETCH_CAMPAIGN_SUCCESS'
export const FETCH_CAMPAIGN_FAILURE = 'FETCH_CAMPAIGN_FAILURE'

export const FETCH_CAMPAIGN_DETAIL_REQUEST = 'FETCH_CAMPAIGN_DETAIL_REQUEST'
export const FETCH_CAMPAIGN_DETAIL_SUCCESS = 'FETCH_CAMPAIGN_DETAIL_SUCCESS'
export const FETCH_CAMPAIGN_DETAIL_FAILURE = 'FETCH_CAMPAIGN_DETAIL_FAILURE'

export const FETCH_CAMPAIGN_EDIT_REQUEST = 'FETCH_CAMPAIGN_EDIT_REQUEST'
export const FETCH_CAMPAIGN_EDIT_SUCCESS = 'FETCH_CAMPAIGN_EDIT_SUCCESS'
export const FETCH_CAMPAIGN_EDIT_FAILURE = 'FETCH_CAMPAIGN_EDIT_FAILURE'

export const SAVE_CAMPAIGN_CREATE_REQUEST = 'SAVE_CAMPAIGN_CREATE_REQUEST'
export const SAVE_CAMPAIGN_CREATE_SUCCESS = 'SAVE_CAMPAIGN_CREATE_SUCCESS'
export const SAVE_CAMPAIGN_CREATE_FAILURE = 'SAVE_CAMPAIGN_CREATE_FAILURE'


export const CREATE_CAMPAIGN_CLEAN_REQUEST = 'CREATE_CAMPAIGN_CLEAN_REQUEST'
export const DETAIL_CAMPAIGN_CLEAN_REQUEST = 'DETAIL_CAMPAIGN_CLEAN_REQUEST'
export const EDIT_CAMPAIGN_CLEAN_REQUEST = 'EDIT_CAMPAIGN_CLEAN_REQUEST'

export const CREATE_CAMPAIGN_AUTHORIZERS_CHANGE_REQUEST='CREATE_CAMPAIGN_AUTHORIZERS_CHANGE_REQUEST'
export const CREATE_CAMPAIGN_AUTHORIZERS_CHANGE='CREATE_CAMPAIGN_AUTHORIZERS_CHANGE'

export const EDIT_CAMPAIGN_AUTHORIZERS_CHANGE_REQUEST='EDIT_CAMPAIGN_AUTHORIZERS_CHANGE_REQUEST'
export const EDIT_CAMPAIGN_AUTHORIZERS_CHANGE='EDIT_CAMPAIGN_AUTHORIZERS_CHANGE'

export const EDIT_CAMPAIGN_AUTH_TYPE_CHECK_REQUEST = 'EDIT_CAMPAIGN_AUTH_TYPE_CHECK_REQUEST'
export const EDIT_CAMPAIGN_AUTH_TYPE_CHECK = 'EDIT_CAMPAIGN_AUTH_TYPE_CHECK'
export const EDIT_CAMPAIGN_AUTH_TYPE_CHECK_SUCCESS = 'EDIT_CAMPAIGN_AUTH_TYPE_CHECK_SUCCESS'
export const EDIT_CAMPAIGN_AUTH_TYPE_CHECK_FAILURE = 'EDIT_CAMPAIGN_AUTH_TYPE_CHECK_FAILURE'

export const EDIT_CAMPAIGN_ENABLED_FILED_CHANGE_REQUEST = 'EDIT_CAMPAIGN_ENABLED_FILED_CHANGE_REQUEST'
export const EDIT_CAMPAIGN_ENABLED_FILED_CHANGE = 'EDIT_CAMPAIGN_ENABLED_FILED_CHANGE'

export const EDIT_CAMPAIGN_CORPORATE_FILED_CHANGE_REQUEST = 'EDIT_CAMPAIGN_CORPORATE_FILED_CHANGE_REQUEST'
export const EDIT_CAMPAIGN_CORPORATE_FILED_CHANGE = 'EDIT_CAMPAIGN_CORPORATE_FILED_CHANGE'

export const EDIT_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE_REQUEST = 'EDIT_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE_REQUEST'
export const EDIT_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE = 'EDIT_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE'

export const EDIT_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE_REQUEST = 'EDIT_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE_REQUEST'
export const EDIT_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE = 'EDIT_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE'

export const CREATE_CAMPAIGN_ENABLED_FILED_CHANGE_REQUEST = 'CREATE_CAMPAIGN_ENABLED_FILED_CHANGE_REQUEST'
export const CREATE_CAMPAIGN_ENABLED_FILED_CHANGE = 'CREATE_CAMPAIGN_ENABLED_FILED_CHANGE'

export const CREATE_CAMPAIGN_AUTH_TYPE_CHECK_REQUEST = 'CREATE_CAMPAIGN_AUTH_TYPE_CHECK_REQUEST'
export const CREATE_CAMPAIGN_AUTH_TYPE_CHECK = 'CREATE_CAMPAIGN_AUTH_TYPE_CHECK'
export const CREATE_CAMPAIGN_AUTH_TYPE_CHECK_SUCCESS = 'CREATE_CAMPAIGN_AUTH_TYPE_CHECK_SUCCESS'
export const CREATE_CAMPAIGN_AUTH_TYPE_CHECK_FAILURE = 'CREATE_CAMPAIGN_AUTH_TYPE_CHECK_FAILURE'

export const CREATE_CAMPAIGN_CORPORATE_FILED_CHANGE_REQUEST = 'CREATE_CAMPAIGN_CORPORATE_FILED_CHANGE_REQUEST'
export const CREATE_CAMPAIGN_CORPORATE_FILED_CHANGE = 'CREATE_CAMPAIGN_CORPORATE_FILED_CHANGE'

export const CREATE_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE_REQUEST = 'CREATE_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE_REQUEST'
export const CREATE_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE = 'CREATE_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE'

export const CREATE_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE_REQUEST = 'CREATE_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE_REQUEST'
export const CREATE_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE = 'CREATE_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE'


export const UPDATE_CAMPAIGN_EDIT_REQUEST = 'UPDATE_CAMPAIGN_EDIT_REQUEST'
export const UPDATE_CAMPAIGN_EDIT_SUCCESS = 'UPDATE_CAMPAIGN_EDIT_SUCCESS'
export const UPDATE_CAMPAIGN_EDIT_FAILURE = 'UPDATE_CAMPAIGN_EDIT_FAILURE'

export const ENABLE_CAMPAIGN_REQUEST = 'ENABLE_CAMPAIGN_REQUEST'
export const ENABLE_CAMPAIGN_SUCCESS = 'ENABLE_CAMPAIGN_SUCCESS'
export const ENABLE_CAMPAIGN_FAILURE = 'ENABLE_CAMPAIGN_FAILURE'

export const DISABLE_CAMPAIGN_REQUEST = 'DISABLE_CAMPAIGN_REQUEST'
export const DISABLE_CAMPAIGN_SUCCESS = 'DISABLE_CAMPAIGN_SUCCESS'
export const DISABLE_CAMPAIGN_FAILURE = 'DISABLE_CAMPAIGN_FAILURE'

export const CREATE_CAMPAIGN_CLEAN = 'CREATE_CAMPAIGN_CLEAN'

export const EDIT_CAMPAIGN_CLEAN = 'EDIT_CAMPAIGN_CLEAN'

export const DETAIL_CAMPAIGN_CLEAN = 'DETAIL_CAMPAIGN_CLEAN'

export const FETCH_FILES_REQUEST = 'FETCH_FILES_REQUEST'
export const FETCH_FILES_SUCCESS = 'FETCH_FILES_SUCCESS'
export const FETCH_FILES_FAILURE = 'FETCH_FILES_FAILURE'

export const UPDATE_SELECTED_FILE_STATUS='UPDATE_SELECTED_FILE_STATUS'



export const HOME_PAGE_MENU_REQUEST = 'HOME_PAGE_MENU_REQUEST'
export const USER_PAGE_MENU_REQUEST = 'USER_PAGE_MENU_REQUEST'
export const FILE_PAGE_MENU_REQUEST = 'FILE_PAGE_MENU_REQUEST'
export const BANK_PAGE_MENU_REQUEST = 'BANK_PAGE_MENU_REQUEST'
export const CORPORATE_PAGE_MENU_REQUEST = 'CORPORATE_PAGE_MENU_REQUEST'
export const CAMPAIGN_PAGE_MENU_REQUEST = 'CAMPAIGN_PAGE_MENU_REQUEST'
export const PROFILE_PAGE_MENU_REQUEST = 'PROFILE_PAGE_MENU_REQUEST'
export const REPORT_PAGE_MENU_REQUEST = 'REPORT_PAGE_MENU_REQUEST'
export const FAQ_PAGE_MENU_REQUEST = 'FAQ_PAGE_MENU_REQUEST'

export const USER_CREATE_PAGE_REQUEST = 'USER_CREATE_PAGE_REQUEST'
export const CORPORATE_CREATE_PAGE_REQUEST = 'CORPORATE_CREATE_PAGE_REQUEST'
export const CAMPAIGN_CREATE_PAGE_REQUEST = 'CAMPAIGN_CREATE_PAGE_REQUEST'

export const FILE_UPLOAD_PAGE_REQUEST = 'FILE_FILE_UPLOAD_PAGE_REQUEST'

export const FILE_UPLOAD_REQUEST = 'FILE_UPLOAD_REQUEST'
export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS'
export const FILE_UPLOAD_FAILURE = 'FILE_UPLOAD_FAILURE'

export const FILE_UPLOAD_EMPTY_FILE = 'FILE_UPLOAD_EMPTY_FILE'

export const FILE_UPLOAD_FILE_FILED_CHANGE_REQUEST = 'FILE_UPLOAD_FILE_FILED_CHANGE_REQUEST'
export const FILE_UPLOAD_FILE_FILED_CHANGE = 'FILE_UPLOAD_FILE_FILED_CHANGE'

export const FILE_UPLOAD_CLEAN_REQUEST = 'FILE_UPLOAD_CLEAN_REQUEST'
export const FILE_UPLOAD_CLEAN = 'FILE_UPLOAD_CLEAN'

export const APPROVE_FILE_REQUEST = 'APPROVE_FILE_REQUEST'
export const APPROVE_FILE_SUCCESS = 'APPROVE_FILE_SUCCESS'
export const APPROVE_FILE_FAILURE = 'APPROVE_FILE_FAILURE'

export const DOWNLOAD_ERROR_FILE_REQUEST = 'DOWNLOAD_ERROR_FILE_REQUEST'
export const DOWNLOAD_ERROR_FILE_SUCCESS = 'DOWNLOAD_ERROR_FILE_SUCCESS'
export const DOWNLOAD_ERROR_FILE_FAILURE = 'DOWNLOAD_ERROR_FILE_FAILURE'

export const FETCH_PLICKS_SUCCESS = 'FETCH_PLICKS_SUCCESS'
export const SET_FILE_BANK_ID = 'SET_FILE_BANK_ID'
export const FETCH_PLICKS_FAILURE = 'FETCH_PLICKS_FAILURE'
export const FETCH_PLICKS_REQUEST = 'FETCH_PLICKS_REQUEST'

export const FETCH_PLICKS_PAGE_FAILURE = 'FETCH_PLICKS_PAGE_FAILURE'
export const FETCH_PLICKS_PAGE_REQUEST = 'FETCH_PLICKS_PAGE_REQUEST'
export const FETCH_PLICKS_PAGE_SUCCESS = 'FETCH_PLICKS_PAGE_SUCCESS'

export const FETCH_PLICK_DETAIL_REQUEST = 'FETCH_PLICK_DETAIL_REQUEST'
export const FETCH_PLICK_DETAIL_SUCCESS = 'FETCH_PLICK_DETAIL_SUCCESS'
export const FETCH_PLICK_DETAIL_FAILURE = 'FETCH_PLICK_DETAIL_FAILURE'

export const PLICK_DETAIL_FIRST_NAME_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_FIRST_NAME_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_LAST_NAME_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_LAST_NAME_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_AMOUNT_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_AMOUNT_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_RECEIVER_NAME_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_RECEIVER_NAME_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_RECEIVER_DEVICE_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_RECEIVER_DEVICE_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_ACTIVATION_DATE_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_ACTIVATION_DATE_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_SENDER_COMPANY_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_SENDER_COMPANY_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_ID_BANK_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_ID_BANK_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_SENDER_DEVICE_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_SENDER_DEVICE_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_ID_LOGO_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_ID_LOGO_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_CAUSAL_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_CAUSAL_FIELD_CHANGE_REQUEST'

export const PLICK_DETAIL_UPDATE_REQUEST = 'PLICK_DETAIL_UPDATE_REQUEST'
export const PLICK_DETAIL_UPDATE_REQUEST_SUCCESS = 'PLICK_DETAIL_UPDATE_REQUEST_SUCCESS'
export const PLICK_DETAIL_UPDATE_REQUEST_FAILURE = 'PLICK_DETAIL_UPDATE_REQUEST_FAILURE'

export const PLICK_DETAIL_FIRST_NAME_FIELD_CHANGE = 'PLICK_DETAIL_FIRST_NAME_FIELD_CHANGE'
export const PLICK_DETAIL_LAST_NAME_FIELD_CHANGE = 'PLICK_DETAIL_LAST_NAME_FIELD_CHANGE'
export const PLICK_DETAIL_AMOUNT_FIELD_CHANGE = 'PLICK_DETAIL_AMOUNT_FIELD_CHANGE'
export const PLICK_DETAIL_RECEIVER_NAME_FIELD_CHANGE = 'PLICK_DETAIL_RECEIVER_NAME_FIELD_CHANGE'
export const PLICK_DETAIL_RECEIVER_DEVICE_FIELD_CHANGE = 'PLICK_DETAIL_RECEIVER_DEVICE_FIELD_CHANGE'
export const PLICK_DETAIL_ACTIVATION_DATE_FIELD_CHANGE = 'PLICK_DETAIL_ACTIVATION_DATE_FIELD_CHANGE'
export const PLICK_DETAIL_SENDER_COMPANY_FIELD_CHANGE = 'PLICK_DETAIL_SENDER_COMPANY_FIELD_CHANGE'
export const PLICK_DETAIL_ID_BANK_FIELD_CHANGE = 'PLICK_DETAIL_ID_BANK_FIELD_CHANGE'
export const PLICK_DETAIL_SENDER_DEVICE_FIELD_CHANGE = 'PLICK_DETAIL_SENDER_DEVICE_FIELD_CHANGE'
export const PLICK_DETAIL_ID_LOGO_FIELD_CHANGE = 'PLICK_DETAIL_ID_LOGO_FIELD_CHANGE'
export const PLICK_DETAIL_CAUSAL_FIELD_CHANGE = 'PLICK_DETAIL_CAUSAL_FIELD_CHANGE'

export const DETAIL_PLICK_CLEAN_REQUEST = 'DETAIL_PLICK_CLEAN_REQUEST'
export const DETAIL_PLICK_CLEAN = 'DETAIL_PLICK_CLEAN'

export const FETCH_PROFILE_EDIT_SUCCESS = 'FETCH_PROFILE_EDIT_SUCCESS'
export const FETCH_PROFILE_EDIT_FAILURE = 'FETCH_PROFILE_EDIT_FAILURE'
export const EDIT_PROFILE_ID_BANK_FIELD_CHANGE = 'EDIT_PROFILE_ID_BANK_FIELD_CHANGE'
export const EDIT_PROFILE_CORPORATE_SENDER_ID_FIELD_CHANGE = 'EDIT_PROFILE_CORPORATE_SENDER_ID_FIELD_CHANGE'
export const EDIT_PROFILE_FULL_NAME_FIELD_CHANGE = 'EDIT_PROFILE_FULL_NAME_FIELD_CHANGE'
export const EDIT_PROFILE_DESCRIPTION_FIELD_CHANGE = 'EDIT_PROFILE_DESCRIPTION_FIELD_CHANGE'
export const EDIT_PROFILE_ENABLED_FIELD_CHANGE = 'EDIT_PROFILE_ENABLED_FIELD_CHANGE'
export const EDIT_PROFILE_PROFILE_NAME_FIELD_CHANGE = 'EDIT_PROFILE_PROFILE_NAME_FIELD_CHANGE'
export const EDIT_PROFILE_PHONE_FIELD_CHANGE = 'EDIT_PROFILE_PHONE_FIELD_CHANGE'
export const EDIT_PROFILE_EMAIL_FIELD_CHANGE = 'EDIT_PROFILE_EMAIL_FIELD_CHANGE'
export const EDIT_PROFILE_RESET_FIELD_CHANGE = 'EDIT_PROFILE_RESET_FIELD_CHANGE'
export const EDIT_PROFILE_PASSWORD_FIELD_CHANGE = 'EDIT_PROFILE_PASSWORD_FIELD_CHANGE'
export const EDIT_PROFILE_PASSWORD_CONFIRM_FIELD_CHANGE = 'EDIT_PROFILE_PASSWORD_CONFIRM_FIELD_CHANGE'
export const EDIT_PROFILE_ROLE_FIELD_CHANGE = 'EDIT_PROFILE_ROLE_FIELD_CHANGE'
export const EDIT_PROFILE_CLEAN = 'EDIT_PROFILE_CLEAN'

export const EDIT_PROFILE_ID_BANK_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_ID_BANK_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_FULL_NAME_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_FULL_NAME_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_DESCRIPTION_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_DESCRIPTION_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_ENABLED_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_ENABLED_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_PROFILE_NAME_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_PROFILE_NAME_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_PHONE_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_PHONE_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_EMAIL_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_EMAIL_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_RESET_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_RESET_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_PASSWORD_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_PASSWORD_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_PASSWORD_CONFIRM_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_PASSWORD_CONFIRM_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_ROLE_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_ROLE_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_CLEAN_REQUEST = 'EDIT_PROFILE_CLEAN_REQUEST'

export const UPDATE_PROFILE_EDIT_REQUEST = 'UPDATE_PROFILE_EDIT_REQUEST'
export const UPDATE_PROFILE_EDIT_SUCCESS = 'UPDATE_PROFILE_EDIT_SUCCESS'
export const UPDATE_PROFILE_EDIT_FAILURE = 'UPDATE_PROFILE_EDIT_FAILURE'
export const FETCH_PROFILE_EDIT_REQUEST = 'FETCH_PROFILE_EDIT_REQUEST'

export const EDIT_USER_PICTURE_UPLOAD_REQUEST = 'EDIT_USER_PICTURE_UPLOAD_REQUEST'
export const EDIT_USER_PICTURE_UPLOAD = 'EDIT_USER_PICTURE_UPLOAD'
export const EDIT_USER_PASSWORD_CHANGE_REQUEST = 'EDIT_USER_PASSWORD_CHANGE_REQUEST'
export const EDIT_USER_PASSWORD_CHANGE = 'EDIT_USER_PASSWORD_CHANGE'


export const SEND_FILE_REQUEST = 'SEND_FILE_REQUEST'
export const SEND_FILE_FAILURE = 'SEND_FILE_FAILURE'
export const SEND_FILE_SUCCESS = 'SEND_FILE_SUCCESS'

export const EDIT_BANK_IMAGE_UPLOAD_REQUEST='EDIT_BANK_IMAGE_UPLOAD_REQUEST'
export const EDIT_BANK_IMAGE_UPLOAD = 'EDIT_BANK_IMAGE_UPLOAD'


export const AUTHENTICATED_USER_LOGO_UPDATE='AUTHENTICATED_USER_LOGO_UPDATE'
export const AUTHENTICATED_BANK_SECONDARY_COLOR_CHANGE='AUTHENTICATED_BANK_SECONDARY_COLOR_CHANGE'
export const AUTHENTICATED_BANK_PRIMARY_COLOR_CHANGE='AUTHENTICATED_BANK_PRIMARY_COLOR_CHANGE'

export const BANK_PRIMARY_COLOR_CHANGE_REQUEST='BANK_PRIMARY_COLOR_CHANGE_REQUEST'
export const BANK_PRIMARY_COLOR_CHANGE='BANK_PRIMARY_COLOR_CHANGE'
export const BANK_SECONDARY_COLOR_CHANGE_REQUEST='BANK_SECONDARY_COLOR_CHANGE_REQUEST'
export const BANK_SECONDARY_COLOR_CHANGE='BANK_SECONDARY_COLOR_CHANGE'

export const UPDATE_CONTO_CORRENTE_EDIT_REQUEST = 'UPDATE_CONTO_CORRENTE_EDIT_REQUEST'
export const UPDATE_CONTO_CORRENTE_EDIT_SUCCESS = 'UPDATE_CONTO_CORRENTE_EDIT_SUCCESS'
export const UPDATE_CONTO_CORRENTE_EDIT_FAILURE = 'UPDATE_CONTO_CORRENTE_EDIT_FAILURE'

export const SAVE_CONTO_CORRENTE_CREATE_REQUEST = 'SAVE_CONTO_CORRENTE_CREATE_REQUEST'
export const SAVE_CONTO_CORRENTE_CREATE_SUCCESS = 'SAVE_CONTO_CORRENTE_CREATE_SUCCESS'
export const SAVE_CONTO_CORRENTE_CREATE_FAILURE = 'SAVE_CONTO_CORRENTE_CREATE_FAILURE'

export const FETCH_CONTO_CORRENTE_REQUEST = 'FETCH_CONTO_CORRENTE_REQUEST'
export const FETCH_CONTO_CORRENTE_SUCCESS = 'FETCH_CONTO_CORRENTE_SUCCESS'
export const FETCH_CONTO_CORRENTE_FAILURE = 'FETCH_CONTO_CORRENTE_FAILURE'

export const DISABLE_CONTO_CORRENTE_REQUEST = 'DISABLE_CONTO_CORRENTE_REQUEST'
export const DISABLE_CONTO_CORRENTE_SUCCESS = 'DISABLE_CONTO_CORRENTE_SUCCESS'
export const DISABLE_CONTO_CORRENTE_FAILURE = 'DISABLE_CONTO_CORRENTE_FAILURE'

export const ENABLE_CONTO_CORRENTE_REQUEST = 'ENABLE_CONTO_CORRENTE_REQUEST'
export const ENABLE_CONTO_CORRENTE_SUCCESS = 'ENABLE_CONTO_CORRENTE_SUCCESS'
export const ENABLE_CONTO_CORRENTE_FAILURE = 'ENABLE_CONTO_CORRENTE_FAILURE'

export const CREATE_CONTO_CORRENTE_ENABLED_FILED_CHANGE_REQUEST = 'CREATE_CONTO_CORRENTE_ENABLED_FILED_CHANGE_REQUEST'
export const CREATE_CONTO_CORRENTE_ENABLED_FILED_CHANGE = 'CREATE_CONTO_CORRENTE_ENABLED_FILED_CHANGE'

export const CREATE_CONTO_CORRENTE_CLEAN_REQUEST = 'CREATE_CONTO_CORRENTE_CLEAN_REQUEST'
export const CREATE_CONTO_CORRENTE_CLEAN = 'CREATE_CONTO_CORRENTE_CLEAN'

export const EDIT_CONTO_CORRENTE_CLEAN_REQUEST = 'EDIT_CONTO_CORRENTE_CLEAN_REQUEST'
export const EDIT_CONTO_CORRENTE_CLEAN = 'EDIT_CONTO_CORRENTE_CLEAN'

export const CREATE_CONTO_CORRENTE_NOTE_FILED_CHANGE_REQUEST = 'CREATE_CONTO_CORRENTE_NOTE_FILED_CHANGE_REQUEST'
export const CREATE_CONTO_CORRENTE_NOTE_FILED_CHANGE = 'CREATE_CONTO_CORRENTE_NOTE_FILED_CHANGE'

export const CREATE_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE_REQUEST = 'CREATE_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE_REQUEST'
export const CREATE_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE = 'CREATE_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE'

export const CREATE_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE_REQUEST = 'CREATE_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE_REQUEST'
export const CREATE_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE = 'CREATE_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE'

export const EDIT_CONTO_CORRENTE_NOTE_FILED_CHANGE_REQUEST = 'EDIT_CONTO_CORRENTE_NOTE_FILED_CHANGE_REQUEST'
export const EDIT_CONTO_CORRENTE_NOTE_FILED_CHANGE = 'EDIT_CONTO_CORRENTE_NOTE_FILED_CHANGE'

export const EDIT_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE_REQUEST = 'EDIT_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE_REQUEST'
export const EDIT_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE = 'EDIT_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE'

export const EDIT_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE_REQUEST = 'EDIT_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE_REQUEST'
export const EDIT_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE = 'EDIT_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE'

export const EDIT_CONTO_CORRENTE_PAGE_REQUEST = 'EDIT_CONTO_CORRENTE_PAGE_REQUEST'
export const CREATE_CONTO_CORRENTE_PAGE_REQUEST = 'CREATE_CONTO_CORRENTE_PAGE_REQUEST'

export const FETCH_CONTO_CORRENTE_EDIT_REQUEST = 'FETCH_CONTO_CORRENTE_EDIT_REQUEST'
export const FETCH_CONTO_CORRENTE_EDIT_SUCCESS = 'FETCH_CONTO_CORRENTE_EDIT_SUCCESS'
export const FETCH_CONTO_CORRENTE_EDIT_FAILURE = 'FETCH_CONTO_CORRENTE_EDIT_FAILURE'

export const FILE_UPLOAD_CONTO_CORRENTE_FILED_CHANGE_REQUEST = 'FILE_UPLOAD_CONTO_CORRENTE_FILED_CHANGE_REQUEST'
export const FILE_UPLOAD_CONTO_CORRENTE_FILED_CHANGE = 'FILE_UPLOAD_CONTO_CORRENTE_FILED_CHANGE'
export const FILE_UPLOAD_CAMPAIGN_FILED_CHANGE_REQUEST = 'FILE_UPLOAD_CAMPAIGN_FILED_CHANGE_REQUEST'
export const FILE_UPLOAD_CAMPAIGN_FILED_CHANGE = 'FILE_UPLOAD_CAMPAIGN_FILED_CHANGE'

export const FILE_UPLOAD_TOGGLE_EMPTY_FILE = 'FILE_UPLOAD_TOGGLE_EMPTY_FILE'

export const EDIT_CORPORATE_CORPORATE_LOGO_FILED_CHANGE_REQUEST = 'EDIT_CORPORATE_CORPORATE_LOGO_FILED_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_LOGO_FILED_CHANGE = 'EDIT_CORPORATE_CORPORATE_LOGO_FILED_CHANGE'

export const CREATE_CORPORATE_CORPORATE_LOGO_FILED_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_LOGO_FILED_CHANGE_REQUEST'
export const CREATE_CORPORATE_CORPORATE_LOGO_FILED_CHANGE = 'CREATE_CORPORATE_CORPORATE_LOGO_FILED_CHANGE'

export const CORPORATE_PRIMARY_COLOR_CHANGE_REQUEST = 'CORPORATE_PRIMARY_COLOR_CHANGE_REQUEST'
export const CORPORATE_PRIMARY_COLOR_CHANGE = 'CORPORATE_PRIMARY_COLOR_CHANGE'

export const CORPORATE_SECONDARY_COLOR_CHANGE_REQUEST = 'CORPORATE_SECONDARY_COLOR_CHANGE_REQUEST'
export const CORPORATE_SECONDARY_COLOR_CHANGE = 'CORPORATE_SECONDARY_COLOR_CHANGE'

export const CREATE_CORPORATE_PRIMARY_COLOR_CHANGE_REQUEST = 'CREATE_CORPORATE_PRIMARY_COLOR_CHANGE_REQUEST'
export const CREATE_CORPORATE_PRIMARY_COLOR_CHANGE = 'CREATE_CORPORATE_PRIMARY_COLOR_CHANGE'

export const CREATE_CORPORATE_SECONDARY_COLOR_CHANGE_REQUEST = 'CREATE_CORPORATE_SECONDARY_COLOR_CHANGE_REQUEST'
export const CREATE_CORPORATE_SECONDARY_COLOR_CHANGE = 'CREATE_CORPORATE_SECONDARY_COLOR_CHANGE'

export const AUTHENTICATED_CORPORATE_SECONDARY_COLOR_CHANGE = 'AUTHENTICATED_CORPORATE_SECONDARY_COLOR_CHANGE'
export const AUTHENTICATED_CORPORATE_PRIMARY_COLOR_CHANGE = 'AUTHENTICATED_CORPORATE_PRIMARY_COLOR_CHANGE'

export const AUTHENTICATED_CORPORATE_USER_LOGO_UPDATE = 'AUTHENTICATED_CORPORATE_USER_LOGO_UPDATE'

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE'

export const DELETE_BANK_REQUEST = 'DELETE_BANK_REQUEST'
export const DELETE_BANK_SUCCESS = 'DELETE_BANK_SUCCESS'
export const DELETE_BANK_FAILURE = 'DELETE_BANK_FAILURE'

export const DELETE_CORPORATE_REQUEST = 'DELETE_CORPORATE_REQUEST'
export const DELETE_CORPORATE_SUCCESS = 'DELETE_CORPORATE_SUCCESS'
export const DELETE_CORPORATE_FAILURE = 'DELETE_CORPORATE_FAILURE'

export const DELETE_CAMPAIGN_REQUEST = 'DELETE_CAMPAIGN_REQUEST'
export const DELETE_CAMPAIGN_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS'
export const DELETE_CAMPAIGN_FAILURE = 'DELETE_CAMPAIGN_FAILURE'

export const DELETE_CONTO_CORRENTE_REQUEST = 'DELETE_CONTO_CORRENTE_REQUEST'
export const DELETE_CONTO_CORRENTE_SUCCESS = 'DELETE_CONTO_CORRENTE_SUCCESS'
export const DELETE_CONTO_CORRENTE_FAILURE = 'DELETE_CONTO_CORRENTE_FAILURE'

export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const TOGGLE_APPROVAL_MODAL='TOGGLE_APPROVAL_MODAL'
export const TOGGLE_UPLOAD_MODAL='TOGGLE_UPLOAD_MODAL'
export const APPROVAL_OTP_REQUEST='APPROVAL_OTP_REQUEST'
export const APPROVAL_OTP_RESPONSE='APPROVAL_OTP_RESPONSE'
export const AUTHENTICATION_CLEAN_TOKEN='AUTHENTICATION_CLEAN_TOKEN'
export const APPROVE_OTP_CHANGE='APPROVE_OTP_CHANGE'

export const AUTHENTICATION_CLEAR_RESET_PASSWORD='AUTHENTICATION_CLEAR_RESET_PASSWORD'

export const CREATE_USER_LANGUAGE_FIELD_CHANGE_REQUEST ='CREATE_USER_LANGUAGE_FIELD_CHANGE_REQUEST'
export const CREATE_USER_LANGUAGE_FIELD_CHANGE =' CREATE_USER_LANGUAGE_FIELD_CHANGE'

export const EDIT_USER_LANGUAGE_FIELD_CHANGE_REQUEST ='EDIT_USER_LANGUAGE_FIELD_CHANGE_REQUEST'
export const EDIT_USER_LANGUAGE_FIELD_CHANGE =' EDIT_USER_LANGUAGE_FIELD_CHANGE'


export const FETCH_USER_STATS_REQUEST='FETCH_USER_STATS_REQUEST'
export const FETCH_USER_STATS_SUCCESS='FETCH_USER_STATS_SUCCESS'
export const FETCH_USER_STATS_FAILURE='FETCH_USER_STATS_FAILURE'

export const FETCH_BANK_STATS_REQUEST='FETCH_BANK_STATS_REQUEST'
export const FETCH_BANK_STATS_SUCCESS='FETCH_BANK_STATS_SUCCESS'
export const FETCH_BANK_STATS_FAILURE='FETCH_BANK_STATS_FAILURE'

export const FETCH_FILE_STATS_REQUEST='FETCH_FILE_STATS_REQUEST'
export const FETCH_FILE_STATS_SUCCESS='FETCH_FILE_STATS_SUCCESS'
export const FETCH_FILE_STATS_FAILURE='FETCH_FILE_STATS_FAILURE'

export const FETCH_FILE_HISTORY_REQUEST = 'FETCH_FILE_HISTORY_REQUEST'
export const FETCH_FILE_HISTORY_SUCCESS = 'FETCH_FILE_HISTORY_SUCCESS'
export const FETCH_FILE_HISTORY_FAILURE = 'FETCH_FILE_HISTORY_FAILURE'

export const EDIT_PROFILE_LANGUAGE_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_LANGUAGE_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_LANGUAGE_FIELD_CHANGE = 'EDIT_PROFILE_LANGUAGE_FIELD_CHANGE'

export const REPORT_GENERAL_BANK_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_BANK_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_BANK_FIELD_CHANGE = 'REPORT_GENERAL_BANK_FIELD_CHANGE'
export const REPORT_GENERAL_CORPORATE_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_CORPORATE_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_CORPORATE_FIELD_CHANGE = 'REPORT_GENERAL_CORPORATE_FIELD_CHANGE'
export const REPORT_GENERAL_CAMPAIGN_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_CAMPAIGN_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_CAMPAIGN_FIELD_CHANGE = 'REPORT_GENERAL_CAMPAIGN_FIELD_CHANGE'
export const REPORT_GENERAL_FILE_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_FILE_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_FILE_FIELD_CHANGE = 'REPORT_GENERAL_FILE_FIELD_CHANGE'
export const REPORT_GENERAL_DATESTART_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_DATESTART_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_DATESTART_FIELD_CHANGE = 'REPORT_GENERAL_DATESTART_FIELD_CHANGE'
export const REPORT_GENERAL_DATEEND_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_DATEEND_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_DATEEND_FIELD_CHANGE = 'REPORT_GENERAL_DATEEND_FIELD_CHANGE'
export const REPORT_GENERAL_WHATSAPP_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_WHATSAPP_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_WHATSAPP_FIELD_CHANGE = 'REPORT_GENERAL_WHATSAPP_FIELD_CHANGE'
export const REPORT_GENERAL_SMS_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_SMS_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_SMS_FIELD_CHANGE = 'REPORT_GENERAL_SMS_FIELD_CHANGE'
export const REPORT_GENERAL_EMAIL_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_EMAIL_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_EMAIL_FIELD_CHANGE = 'REPORT_GENERAL_EMAIL_FIELD_CHANGE'
export const REPORT_GENERAL_ORDINARY_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_ORDINARY_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_ORDINARY_FIELD_CHANGE = 'REPORT_GENERAL_ORDINARY_FIELD_CHANGE'
export const REPORT_GENERAL_FUTUREDATE_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_FUTUREDATE_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_FUTUREDATE_FIELD_CHANGE = 'REPORT_GENERAL_FUTUREDATE_FIELD_CHANGE'
export const REPORT_GENERAL_STATUS_FIELD_CHANGE_REQUEST = 'REPORT_GENERAL_STATUS_FIELD_CHANGE_REQUEST'
export const REPORT_GENERAL_STATUS_FIELD_CHANGE = 'REPORT_GENERAL_STATUS_FIELD_CHANGE'

export const REPORT_GENERAL_CHART_IMAGE = 'REPORT_GENERAL_CHART_IMAGE'
export const REPORT_GENERAL_CHART_STATUS_IMAGE = 'REPORT_GENERAL_CHART_STATUS_IMAGE'

export const FETCH_REPORT_GENERAL_REQUEST = 'REPORT_GENERAL_REQUEST'
export const FETCH_REPORT_GENERAL_SUCCESS = 'REPORT_GENERAL_SUCCESS'
export const FETCH_REPORT_GENERAL_FAILURE = 'REPORT_GENERAL_FAILURE'

export const FETCH_REPORT_GENERAL_DOWNLOAD_REQUEST = 'FETCH_REPORT_GENERAL_DOWNLOAD_REQUEST'
export const FETCH_REPORT_GENERAL_DOWNLOAD_SUCCESS = 'FETCH_REPORT_GENERAL_DOWNLOAD_SUCCESS'
export const FETCH_REPORT_GENERAL_DOWNLOAD_FAILURE = 'FETCH_REPORT_GENERAL_DOWNLOAD_FAILURE'


export const FETCH_REPORT_GENERAL_DETAILS_DOWNLOAD_REQUEST = 'FETCH_REPORT_GENERAL_DETAILS_DOWNLOAD_REQUEST'
export const FETCH_REPORT_GENERAL_DETAILS_DOWNLOAD_SUCCESS = 'FETCH_REPORT_GENERAL_DETAILS_DOWNLOAD_SUCCESS'
export const FETCH_REPORT_GENERAL_DETAILS_DOWNLOAD_FAILURE = 'FETCH_REPORT_GENERAL_DETAILS_DOWNLOAD_FAILURE'

export const FETCH_REPORT_PLICKSTATUS_TYPE_REQUEST = 'FETCH_REPORT_PLICKSTATUS_TYPE_REQUEST'
export const FETCH_REPORT_PLICKSTATUS_TYPE_SUCCESS = 'FETCH_REPORT_PLICKSTATUS_TYPE_SUCCESS'
export const FETCH_REPORT_PLICKSTATUS_TYPE_FAILURE = 'FETCH_REPORT_PLICKSTATUS_TYPE_FAILURE'

export const FETCH_REPORT_CORPORATE_REQUEST = 'FETCH_REPORT_CORPORATE_REQUEST'
export const FETCH_REPORT_CORPORATE_SUCCESS = 'FETCH_REPORT_CORPORATE_SUCCESS'
export const FETCH_REPORT_CORPORATE_FAILURE = 'FETCH_REPORT_CORPORATE_FAILURE'

export const FETCH_REPORT_CAMPAIGN_REQUEST = 'FETCH_REPORT_CAMPAIGN_REQUEST'
export const FETCH_REPORT_CAMPAIGN_SUCCESS = 'FETCH_REPORT_CAMPAIGN_SUCCESS'
export const FETCH_REPORT_CAMPAIGN_FAILURE = 'FETCH_REPORT_CAMPAIGN_FAILURE'

export const FETCH_REPORT_FILES_REQUEST = 'FETCH_REPORT_FILES_REQUEST'
export const FETCH_REPORT_FILES_SUCCESS = 'FETCH_REPORT_FILES_SUCCESS'
export const FETCH_REPORT_FILES_FAILURE = 'FETCH_REPORT_FILES_FAILURE'


export const REPORT_CORPORATE_FILE_STATS_BANK_FIELD_CHANGE_REQUEST = 'REPORT_CORPORATE_FILE_STATS_BANK_FIELD_CHANGE_REQUEST'
export const REPORT_CORPORATE_FILE_STATS_BANK_FIELD_CHANGE = 'REPORT_CORPORATE_FILE_STATS_BANK_FIELD_CHANGE'
export const REPORT_CORPORATE_FILE_STATS_CORPORATE_FIELD_CHANGE_REQUEST = 'REPORT_CORPORATE_FILE_STATS_CORPORATE_FIELD_CHANGE_REQUEST'
export const REPORT_CORPORATE_FILE_STATS_CORPORATE_FIELD_CHANGE = 'REPORT_CORPORATE_FILE_STATS_CORPORATE_FIELD_CHANGE'

export const FETCH_REPORT_CORPORATE_FILE_STATS_REQUEST = 'REPORT_CORPORATE_FILE_STATS_REQUEST'
export const FETCH_REPORT_CORPORATE_FILE_STATS_SUCCESS = 'REPORT_CORPORATE_FILE_STATS_SUCCESS'
export const FETCH_REPORT_CORPORATE_FILE_STATS_FAILURE = 'REPORT_CORPORATE_FILE_STATS_FAILURE'

export const REPORT_BANK_STATS_BANK_FIELD_CHANGE_REQUEST = 'REPORT_BANK_STATS_BANK_FIELD_CHANGE_REQUEST'
export const REPORT_BANK_STATS_BANK_FIELD_CHANGE = 'REPORT_BANK_STATS_BANK_FIELD_CHANGE'




export const FETCH_REPORT_BANK_STATS_REQUEST = 'REPORT_BANK_STATS_REQUEST'
export const FETCH_REPORT_BANK_STATS_SUCCESS = 'REPORT_BANK_STATS_SUCCESS'
export const FETCH_REPORT_BANK_STATS_FAILURE = 'REPORT_BANK_STATS_FAILURE'

export const FETCH_REPORT_PLICK_STATS_REQUEST = 'REPORT_PLICK_STATS_REQUEST'
export const FETCH_REPORT_PLICK_STATS_SUCCESS = 'REPORT_PLICK_STATS_SUCCESS'
export const FETCH_REPORT_PLICK_STATS_FAILURE = 'REPORT_PLICK_STATS_FAILURE'

export const REPORT_CORPORATE_STATS_CORPORATE_FIELD_CHANGE_REQUEST = 'REPORT_CORPORATE_STATS_CORPORATE_FIELD_CHANGE_REQUEST'
export const REPORT_CORPORATE_STATS_CORPORATE_FIELD_CHANGE = 'REPORT_CORPORATE_STATS_CORPORATE_FIELD_CHANGE'

export const FETCH_REPORT_CORPORATE_STATS_REQUEST = 'REPORT_CORPORATE_STATS_REQUEST'
export const FETCH_REPORT_CORPORATE_STATS_SUCCESS = 'REPORT_CORPORATE_STATS_SUCCESS'
export const FETCH_REPORT_CORPORATE_STATS_FAILURE = 'REPORT_CORPORATE_STATS_FAILURE'

export const CREATE_REPORT_CLEAN = 'CREATE_REPORT_CLEAN'

export const RESET_USER_PASSWORD_REQUEST = 'RESET_USER_PASSWORD_REQUEST'
export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD'
export const CLEAN_ERROR = 'CLEAN_ERROR'

export const EXPIRE_SESSION='EXPIRE_SESSION'

export const AUTH_NAVBAR_BANK_ID_REQUEST = 'AUTH_NAVBAR_BANK_ID_REQUEST'
export const AUTH_NAVBAR_BANK_ID = 'AUTH_NAVBAR_BANK_ID'
export const EDIT_PROFILE_OTP_CHANGE_REQUEST = 'EDIT_PROFILE_OTP_CHANGE_REQUEST'
export const EDIT_PROFILE_OTP_CHANGE = 'EDIT_PROFILE_OTP_CHANGE'

export const EDIT_PROFILE_NEW_PASSWORD_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_NEW_PASSWORD_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_NEW_PASSWORD_FIELD_CHANGE = 'EDIT_PROFILE_NEW_PASSWORD_FIELD_CHANGE'
export const EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CHANGE_REQUEST = 'EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CHANGE_REQUEST'
export const EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CHANGE = 'EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CHANGE'

export const EDIT_PROFILE_NEW_PASSWORD_FIELD_CLEAN_REQUEST = 'EDIT_PROFILE_NEW_PASSWORD_FIELD_CLEAN_REQUEST'
export const EDIT_PROFILE_NEW_PASSWORD_FIELD_CLEAN = 'EDIT_PROFILE_NEW_PASSWORD_FIELD_CLEAN'
export const EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CLEAN_REQUEST = 'EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CLEAN_REQUEST'
export const EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CLEAN = 'EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CLEAN'

export const EDIT_PROFILE_OTP_NOTIFICATION_SEND_REQUEST = 'EDIT_PROFILE_OTP_NOTIFICATION_SEND_REQUEST'

export const TOGGLE_POSITIVE_UPLOAD_MODAL = 'TOGGLE_POSITIVE_UPLOAD_MODAL'
export const TOGGLE_NEGATIVE_UPLOAD_MODAL = 'TOGGLE_NEGATIVE_UPLOAD_MODAL'
export const TOGGLE_EMPTY_UPLOAD_MODAL = 'TOGGLE_EMPTY_UPLOAD_MODAL'

export const TOGGLE_FILE_ERROR_UPLOAD_MODAL = 'TOGGLE_FILE_ERROR_UPLOAD_MODAL'
export const FILE_UPLOAD_ERROR_FILE_FILED_CHANGE = 'FILE_UPLOAD_ERROR_FILE_FILED_CHANGE'

export const FILE_REUPLOAD_REQUEST = 'FILE_REUPLOAD_REQUEST'
export const TOGGLE_FILE_ROW_LIMIT_UPLOAD_MODAL = 'TOGGLE_FILE_ROW_LIMIT_UPLOAD_MODAL'

export const PLICK_DETAIL_TRANSACTION_ID_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_TRANSACTION_ID_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_TRANSACTION_ID_FIELD_CHANGE = 'PLICK_DETAIL_TRANSACTION_ID_FIELD_CHANGE'

export const PLICK_DETAIL_SENDER_ID_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_SENDER_ID_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_SENDER_ID_FIELD_CHANGE = 'PLICK_DETAIL_SENDER_ID_FIELD_CHANGE'

export const PLICK_DETAIL_SENDER_FIRST_NAME_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_SENDER_FIRST_NAME_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_SENDER_FIRST_NAME_FIELD_CHANGE = 'PLICK_DETAIL_SENDER_FIRST_NAME_FIELD_CHANGE'

export const PLICK_DETAIL_SENDER_LAST_NAME_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_SENDER_LAST_NAME_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_SENDER_LAST_NAME_FIELD_CHANGE = 'PLICK_DETAIL_SENDER_LAST_NAME_FIELD_CHANGE'

export const PLICK_DETAIL_SENDER_IS_COMPANY_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_SENDER_IS_COMPANY_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_SENDER_IS_COMPANY_FIELD_CHANGE = 'PLICK_DETAIL_SENDER_IS_COMPANY_FIELD_CHANGE'

export const PLICK_DETAIL_SENDER_ACCOUNT_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_SENDER_ACCOUNT_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_SENDER_ACCOUNT_FIELD_CHANGE = 'PLICK_DETAIL_SENDER_ACCOUNT_FIELD_CHANGE'

export const PLICK_DETAIL_SENDER_LANGUAGE_PREFERENCES_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_SENDER_LANGUAGE_PREFERENCES_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_SENDER_LANGUAGE_PREFERENCES_FIELD_CHANGE = 'PLICK_DETAIL_SENDER_LANGUAGE_PREFERENCES_FIELD_CHANGE'

export const PLICK_DETAIL_SENDER_EXTRA_INFO_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_SENDER_EXTRA_INFO_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_SENDER_EXTRA_INFO_FIELD_CHANGE = 'PLICK_DETAIL_SENDER_EXTRA_INFO_FIELD_CHANGE'

export const PLICK_DETAIL_RECEIVER_IBAN_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_RECEIVER_IBAN_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_RECEIVER_IBAN_FIELD_CHANGE = 'PLICK_DETAIL_RECEIVER_IBAN_FIELD_CHANGE'

export const PLICK_DETAIL_RECEIVER_IBAN_FROM_BANK_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_RECEIVER_IBAN_FROM_BANK_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_RECEIVER_IBAN_FROM_BANK_FIELD_CHANGE = 'PLICK_DETAIL_RECEIVER_IBAN_FROM_BANK_FIELD_CHANGE'

export const PLICK_DETAIL_AMOUNT_STRING_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_AMOUNT_STRING_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_AMOUNT_STRING_FIELD_CHANGE = 'PLICK_DETAIL_AMOUNT_STRING_FIELD_CHANGE'

export const PLICK_DETAIL_NOTES_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_NOTES_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_NOTES_FIELD_CHANGE = 'PLICK_DETAIL_NOTES_FIELD_CHANGE'

export const PLICK_DETAIL_PIN_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_PIN_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_PIN_FIELD_CHANGE = 'PLICK_DETAIL_PIN_FIELD_CHANGE'

export const PLICK_DETAIL_PIN_TYPE_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_PIN_TYPE_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_PIN_TYPE_FIELD_CHANGE = 'PLICK_DETAIL_PIN_TYPE_FIELD_CHANGE'

export const PLICK_DETAIL_RECEIVER_LANGUAGE_PREFERENCES_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_RECEIVER_LANGUAGE_PREFERENCES_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_RECEIVER_LANGUAGE_PREFERENCES_FIELD_CHANGE = 'PLICK_DETAIL_RECEIVER_LANGUAGE_PREFERENCES_FIELD_CHANGE'

export const PLICK_DETAIL_CORRECT_PLICK_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_CORRECT_PLICK_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_CORRECT_PLICK_FIELD_CHANGE = 'PLICK_DETAIL_CORRECT_PLICK_FIELD_CHANGE'

export const PLICK_DETAIL_PLICK_ID_FROM_PORTAL_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_PLICK_ID_FROM_PORTAL_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_PLICK_ID_FROM_PORTAL_FIELD_CHANGE = 'PLICK_DETAIL_PLICK_ID_FROM_PORTAL_FIELD_CHANGE'

export const PLICK_DETAIL_PLICK_TYPE_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_PLICK_TYPE_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_PLICK_TYPE_FIELD_CHANGE = 'PLICK_DETAIL_PLICK_TYPE_FIELD_CHANGE'

export const PLICK_DETAIL_RECEIVER_TYPE_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_RECEIVER_TYPE_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_RECEIVER_TYPE_FIELD_CHANGE = 'PLICK_DETAIL_RECEIVER_TYPE_FIELD_CHANGE'

export const PLICK_DETAIL_BANK_CRO_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_BANK_CRO_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_BANK_CRO_FIELD_CHANGE = 'PLICK_DETAIL_BANK_CRO_FIELD_CHANGE'

export const PLICK_DETAIL_BANK_EXECUTION_DATE_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_BANK_EXECUTION_DATE_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_BANK_EXECUTION_DATE_FIELD_CHANGE = 'PLICK_DETAIL_BANK_EXECUTION_DATE_FIELD_CHANGE'

export const PLICK_DETAIL_CURRENCY_DATE_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_CURRENCY_DATE_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_CURRENCY_DATE_FIELD_CHANGE = 'PLICK_DETAIL_CURRENCY_DATE_FIELD_CHANGE'

export const PLICK_DETAIL_TRANSFER_STATUS_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_TRANSFER_STATUS_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_TRANSFER_STATUS_FIELD_CHANGE = 'PLICK_DETAIL_TRANSFER_STATUS_FIELD_CHANGE'

export const TOGGLE_APPROVAL_AVAILABILITY_MODAL = 'TOGGLE_APPROVAL_AVAILABILITY_MODAL'

export const EDIT_USER_REPORT_SECTION_FIELD_CHANGE = 'EDIT_USER_REPORT_SECTION_FIELD_CHANGE'
export const CREATE_USER_REPORT_SECTION_FIELD_CHANGE = 'CREATE_USER_REPORT_SECTION_FIELD_CHANGE'

export const EDIT_USER_DISTINTE_SECTION_FIELD_CHANGE = 'EDIT_USER_DISTINTE_SECTION_FIELD_CHANGE'
export const CREATE_USER_DISTINTE_SECTION_FIELD_CHANGE = 'CREATE_USER_DISTINTE_SECTION_FIELD_CHANGE'

export const TOGGLE_CORRECTION_MODAL = 'TOGGLE_CORRECTION_MODAL'
export const UPDATE_DETAIL_REQUEST = 'UPDATE_DETAIL_REQUEST'
export const CREATE_CORPORATE_CORPORATE_CHECK_IBAN_FIELD_CHANGE_REQUEST = 'CREATE_CORPORATE_CORPORATE_CHECK_IBAN_FIELD_CHANGE_REQUEST'
export const EDIT_CORPORATE_CORPORATE_CHECK_IBAN_FIELD_CHANGE = 'EDIT_CORPORATE_CORPORATE_CHECK_IBAN_FIELD_CHANGE'

export const PLICK_DETAIL_CHECK_IBAN_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_CHECK_IBAN_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_CHECK_IBAN_CODE_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_CHECK_IBAN_CODE_FIELD_CHANGE_REQUEST'
export const PLICK_DETAIL_VOUCHER_FIELD_CHANGE_REQUEST = 'PLICK_DETAIL_VOUCHER_FIELD_CHANGE_REQUEST'

export const PLICK_DETAIL_CHECK_IBAN_FIELD_CHANGE = 'PLICK_DETAIL_CHECK_IBAN_FIELD_CHANGE'
export const PLICK_DETAIL_CHECK_IBAN_CODE_FIELD_CHANGE = 'PLICK_DETAIL_CHECK_IBAN_CODE_FIELD_CHANGE'
export const PLICK_DETAIL_VOUCHER_FIELD_CHANGE = 'PLICK_DETAIL_VOUCHER_FIELD_CHANGE'

export const FILE_UPLOAD_VOUCHER_FILED_CHANGE_REQUEST = 'FILE_UPLOAD_VOUCHER_FILED_CHANGE_REQUEST'
export const FILE_UPLOAD_CHECK_IBAN_FILED_CHANGE_REQUEST = 'FILE_UPLOAD_CHECK_IBAN_FILED_CHANGE_REQUEST'

export const FILE_UPLOAD_VOUCHER_FILED_CHANGE = 'FILE_UPLOAD_VOUCHER_FILED_CHANGE'
export const FILE_UPLOAD_CHECK_IBAN_FILED_CHANGE = 'FILE_UPLOAD_CHECK_IBAN_FILED_CHANGE'

export const TOGGLE_GENERAL_REPORT_MODAL = 'TOGGLE_GENERAL_REPORT_MODAL'

export const TOGGLE_GENERAL_REPORT_DETAIL_MODAL = 'TOGGLE_GENERAL_REPORT_DETAIL_MODAL'